import { ReactNode } from "react";
import type { User } from "@/types/Users";
import type { Location } from "@/pages/Locations/LocationsSection";
import { Evidence } from "../Evidence/evidence.types";

export interface CocRecord {
  coc_id: number;
  evidence_id: string;
  type: string;
  timestamp: string;
  custody_from: string;
  custody_to: string;
  reason: string;
  signature?: {
    custody_from_sig?: {
      signature: string;
    } | null;
    custody_to_sig?: {
      signature: string;
    } | null;
  } | null;
}

export interface SignatureData {
  signature: string;
  signer: string;
  timestamp: string;
  userAgent: string;
  ip_address: string | null;
  monolith_user: {
    first_name: string;
    last_name: string;
    full_name: string;
    email: string;
    title: string;
    user_id: number;
  };
  esig?: boolean;
}

export interface LocationOption {
  location_id: number;
  location_name: string;
}

export interface UserOption {
  user_id: number;
  full_name: string;
  location_id?: number;
}

export interface ActionItem {
  label: string;
  value: string;
  onClick: () => void;
  visible: boolean;
}

export interface ReportActionItem {
  label: string;
  value: string;
  onClick: () => void;
}

// Specific type for dropdown item click events
export interface DropdownItemClickArgs {
  value?: string | number;
  label?: string;
  data?: Record<string, unknown>;
  event?: Event;
}

export interface DropDownItem {
  label: string;
  value: string;
  onClick?: (args?: DropdownItemClickArgs) => void;
}

// CoC Request object type for onSubmit callbacks
export interface CocRequestObject {
  caseInfo?: {
    case_id: number;
  };
  evidenceInfo?: {
    evidence_id: number;
    uuid: string;
    evidence_number: string;
  };
  moveData?: Record<string, unknown>;
  [key: string]: unknown;
}

// Common Modal Props
export interface BaseCocModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit: (data?: CocRequestObject) => void;
  defaultInfo: Evidence;
}

export interface CocModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit: (data?: CocRequestObject) => void;
  defaultInfo: CocRecord;
}

// Component Props for detail display
export interface DetailItemProps {
  className?: string;
  label: string;
  value: ReactNode;
  labelProps?: Record<string, unknown>;
  valueProps?: Record<string, unknown>;
}

// Form Data Types for Modals
export interface FormDataWithUser {
  [key: string]: unknown;
  received_by?: User;
  released_by?: User;
  destroyed_by?: User;
}

export interface FormDataWithLocation {
  [key: string]: unknown;
  custody_to?: Location;
  new_location?: Location;
}

// Signature object for CoC operations
export interface CocSignatureObject {
  custody_from_sig?: SignatureData | null;
  custody_to_sig?: SignatureData | null;
}

export const cocTypeOptions = [
  { label: "Move", value: "Move" },
  { label: "Checkout", value: "Checkout" },
  { label: "Release", value: "Release" },
  { label: "Re-Collect", value: "Re-Collect" },
  { label: "Destroy", value: "Destroy" },
];
